import helpers from 'helpers'

const documentSend = (international, document) => {
  if (international) return { internationalDocument: document }

  if (helpers.validates.cnpj.isValid(document)) return { cnpj: document }

  if (helpers.validates.cpf.isValid(document)) return { cpf: document }

  return { internationalDocument: document }
}

export default documentSend
